export const GENERAL = {
    VIDEO_SETTINGS: 'RCV_Web_appSettings_Video',
    PMN_UPDATE: 'RCV_Web_settings_meetings_personalRoomNameSave',
    REDUX_DISPATCH_PERFORMANCE: 'RCV_web_reduxDispatchPerformance',
};

export const IN_MEETING = {
    BUTTONS_TAPPED: 'RCV_Web_inMeeting_buttonClick',
    CHAT_MESSAGE_SENT_PUBLIC: 'RCV_Web_public_chat_message_sent',
    CHAT_MESSAGE_SENT_BROADCAST: 'RCV_Web_broadcast_chat_message_sent',
    CHAT_MESSAGE_SENT_PRIVATE: 'RCV_Web_private_chat_message_sent',
    HOST_MUTE_ALL: 'RCV_Web_inMeeting_Host_muteAll',
    HOST_MUTE_VIDEO_ALL: 'RCV_Web_inMeeting_Host_muteVideoAll',
    HOST_REQUEST_ALL_UNMUTE_MIC: 'RCV_Web_InMeeting_Host_requestAllUnmuteMic',
    HOST_REQUEST_ALL_UNMUTE_VIDEO: 'RCV_Web_InMeeting_Host_requestAllUnmuteVideo',
    HOST_UNLOCK_MEETING: 'RCV_Web_InMeeting_Host_unlockMeeting',
    HOST_LOCK_MEETING: 'RCV_Web_InMeeting_Host_lockMeeting',
    MEETING_E2EE_ENABLED: 'RCV_Web_InMeeting_e2ee_enabled',
    MEETING_E2EE_DISABLED: 'RCV_Web_InMeeting_e2ee_disabled',
    HOST_REQUEST_MIC: 'RCV_Web_InMeeting_Host_requestMic',
    HOST_REQUEST_CAM: 'RCV_Web_InMeeting_Host_requestCam',
    MEETING_END: 'RCV_Web_inMeeting_meetingEnd',
    MAX_ACTIVE_SPEAKERS_ADJUST: 'RCV_Web_inMeeting_maxActiveSpeakersAdjust',
    MEETING_JOIN: 'RCV_Web_inMeeting_meetingJoin',
    MEETING_START: 'RCV_Web_inMeeting_meetingStart',
    SCREEN_SHARE: 'RCV_Web_inMeeting_screenShare',
    SETTINGS_UPDATE: 'RCV_Web_appSettings_preferencesSettingsUpdate',
    TERMINATED: 'RCV_Web_inMeeting_Terminated',
    INVITE_PARTICIPANT: 'RCV_Web_inMeeting_inviteParticipant',
    FORCED_SYNC_ONSFU_NEW_STREAMS: 'RCV_Web_RCT_call_forced_sync_on_SFU_new_streams',
    JOIN_AUDIO: 'RCV_Web_inMeeting_JoinAudio',
    ASSIGN_MODERATOR_LEAVE_WITHOUT_ASSIGN: 'RCV_Web_inMeeting_Leave_without_assigning_moderator',
    ASSIGN_MODERATOR_LEAVE_FAIL: 'RCV_Web_inMeeting_Assign_moderator_when_leave_failed',
    ASSIGN_MODERATOR_LEAVE_SUCCESS: ' RCV_Web_inMeeting_Assign_moderator_when_leave_success',
    SCHEDULE_ON_BEHALF_NEW_DELEGATE: 'RCV_Web_ScheduleOnBehalf_NewDelegate',
    ENABLE_ANNOTATION: 'RCV_Web_enable_annotation',
    DISABLE_ANNOTATION: 'RCV_Web_disable_annotation',
    PRESENTER_STOP_SCREEN_SHARING: 'RCV_Web_presenter_stop_screen_sharing',
    OPEN_SYSTEM_PREFERENCE_ON_MAC: 'RCV_Web_Open_System_Preference_On_Mac',
    DEVICE_BLOCKED_ON_MAC_BY_SYSTEM: 'RCV_Web_Device_Blocked_On_Mac_By_System',
    PAIRED_AUDIO_SELECTED: 'RCV_Web_InMeeting_PairedAudioDeviceSelected',
    IN_MEETING_PAGE: 'RCV_Web_inMeeting_inMeeting',
    TERMINATED_PAGE: 'Viewed_RCV_Web_Terminated Page',
    MIRRORING_WARNING: 'RCV_Web_ss-mirroring-warning',
    AUTHENTICATION_ERROR_TOASTS_DISPLAY: 'RCV_Web_authentication_errorToastsDisplay',
    SET_MEDIA_DEVICES: 'SET_MEDIA_DEVICES',
    EXTERNAL_LINK_OPENED: 'EXTERNAL_LINK_OPENED',
    HOST_ALLOW_CHATS: 'RCV_Web_inMeeting_Host_allowChats',
    FLOATER_TAB_CLICK: 'RCV_Web_inMeeting_tabClickInParticipantAndChatWindow',
    FLOATER_AI_NOTES_TAB_CLICK: 'RCV_Web_inMeetingNotesButton',
    PAGINATION_FIRST_PAGE: 'RCV_Web_inMeeting_Pagination_First_page',
    PAGINATION_LAST_PAGE: 'RCV_Web_inMeeting_Pagination_Last_page',
    PAGINATION_PREV_PAGE: 'RCV_Web_inMeeting_Pagination_Prev_page',
    PAGINATION_NEXT_PAGE: 'RCV_Web_inMeeting_Pagination_Next_page',
    GALLERY_VIEW_MODE_CHANGE: 'RCV_Web_inMeeting_Gallery_Mode_Change',
    CLOSED_CAPTIONS: 'RCV_Web_inMeeting_closedCaption',
    WAITING_ROOM_HOST_ACTION: 'RCV_Web_inMeeting_waitingRoomHostAction',
    WEATHERMAN_SETTINGS: 'RCV_Web_appSettings_WM',
    REDUCE_SPEAKER_VOLUME: 'RCV_Web_inMeeting_forceReduceVolume',
    NOISE_REDUCTION_LEVEL_CHANGE: 'RCV_Web_NoiseReduction_inMeeting_settings_change',
    AUDIO_METRICS_LOCAL_AUDIO_MISSED: 'RCV_Web_inMeeting_local_audio_missed',
    BREAKOUT_HOST_OPEN_BR: 'RCV_Web_Breakout_hostOpenBR',
    BREAKOUT_HOST_CLOSE_BR: 'RCV_Web_Breakout_hostCloseBR',
    BREAKOUT_PARTICIPANT_LEAVES_BR: 'RCV_Web_Breakout_participantLeaveBR',
    BREAKOUT_HOST_PUSH_PARTICIPANT_INTO_ROOM: 'RCV_Web_Breakout_hostPushParticipantIntoRoom',
    BREAKOUT_PARTICIPANT_JOIN: 'RCV_Web_Breakout_participantJoin',
    AV_SYNC_METRIC: 'RCV_Web_inMeeting_av_desync',
    BATTERY_INFO: 'RCV_Web_inMeeting_Battery_Info',
    BATTERY_POWER_CONNECTED: 'RCV_Web_inMeeting_Battery_PowerConnected',
    BATTERY_POWER_DISCONNECTED: 'RCV_Web_inMeeting_Battery_PowerDisconnected',
    BATTERY_DRAIN_RATE: 'RCV_Web_inMeeting_Battery_DrainRate',
    DESKTOP_CPU_UTILIZATION: 'RCV_web_inMeeting_Desktop_CPU_Utilization',
    WEB_CPU_UTILIZATION: 'RCV_web_inMeeting_Web_CPU_Utilization',
    PERFORMANCE_REPORT: 'RCV_web_inMeeting_Performance_Report',
    VISIBLE_WINDOW_STREAMS_ON: 'RCV_web_inMeeting_visible_window_streams_on',
    INVISIBLE_WINDOW_STREAMS_OFF: 'RCV_web_inMeeting_invisible_window_streams_off',
    CREATE_REACTION: 'RCV_Web/DT_Reaction',
    DELETE_REACTION: 'RCV_Web/DT_Reaction_ResetReaction',
    REACTIONS_FILTER: 'RCV_Web/DT_Reaction_FilterByReactionType',
    RESET_REACTIONS: 'RCV_Web/DT_Reaction_ResetAllReactions',
    DELETE_PARTICIPANT_REACTION: 'RCV_Web/DT_Reaction_ResetParticipantReaction',
    DISALLOW_REACTIONS: 'RCV_Web/DT_Reaction_TurnReactionsOff',
    ALLOW_REACTIONS: 'RCV_Web/DT_Reaction_TurnReactionsOn',
    KRISP_FORCE_STOP: 'RCV_Web_inMeeting_KrispForceStop',
    KRISP_GLITCH_RATE: 'RCV_Web_inMeeting_KrispGlitchRate',
    KRISP_FORCE_ENABLED_BY_NON_MIXED: 'RCV_Web_inMeeting_KrispForceEnabled_By_NonMixed',
    KRISP_AM_SWITCH_TO_KRISP: 'RCV_Web_InMeeting_NCAutomaticallySwitchedToKrisp',
    KRISP_AM_SWITCH_TO_RNNOISE: 'RCV_Web_InMeeting_NCAutomaticallySwitchedToRNNoise',
    KRISP_GLITCH_BUFFER_OVERFLOW: 'RCV_Web_InMeeting_KrispGlitchBufferOverflow',
    KRISP_FAST_DETECTION_OPTIMIZATION_EFFECTIVE:
        'RCV_Web_InMeeting_KrispFastDetectionOptimizationEffective',
    HIGH_CPU_INC_VIDEO_POPUP_SHOWN: 'RCV_Web_inMeeting_HighCPU_incomingVideoPopupShown',
    HIGH_CPU_INC_VIDEO_POPUP_HIDDEN: 'RCV_Web_inMeeting_HighCPU_incomingVideoPopupHidden',
    HIGH_CPU_INC_VIDEO_POPUP_OK_PRESSED: 'RCV_Web_inMeeting_HighCPU_incomingVideoPopupOkPressed',
    HIGH_CPU_INC_VIDEO_POPUP_X_PRESSED: 'RCV_Web_inMeeting_HighCPU_incomingVideoPopupXPressed',
    HIGH_CPU_OUT_VIDEO_POPUP_SHOWN: 'RCV_Web_inMeeting_HighCPU_outgoingVideoPopupShown',
    HIGH_CPU_OUT_VIDEO_POPUP_HIDDEN: 'RCV_Web_inMeeting_HighCPU_outgoingVideoPopupHidden',
    HIGH_CPU_OUT_VIDEO_POPUP_X_PRESSED: 'RCV_Web_inMeeting_HighCPU_outgoingVideoPopupXPressed',
    WB_LAUNCHING: 'RCV_Web_WB_launching',
    WB_RATING_AFTER_MEETING: 'RCV_Web_WB_rating_after_meeting',
    WB_ANALYTICS: 'WB_ANALYTICS',
    DOWNLOAD_CHAT: 'RCV_Web_InMeetingDownloadChat_downloadFile',
    AUTO_DOWNLOAD_CHAT_SWITCH: 'RCV_Web_InMeetingDownloadChat_switchAutoDownload',
    ANNOTATIONS_LAUNCH: 'RCV_Web_annotations_launching',
    ANNOTATIONS_TURN_OFF: 'RCV_Web_Annotations_turnOff',
    ANNOTATIONS_USE_TOOL: 'RCV_Web_Annotations_used_tools',
    ANNOTATIONS_EDIT_OBJECT: 'RCV_Web_Annotations_edit_annotation',
    ANNOTATIONS_UPDATE_TOOL: 'RCV_Web_Annotations_color_thickness_updating',
    ANNOTATIONS_PAINTING: 'RCV_Web_Annotations_painting',
    ANNOTATIONS_ACCESS_UPDATE: 'RCV_Web_Annotations_accessibility',
    ANNOTATIONS_DELETE: 'RCV_Web_Annotations_delete',
    ANNOTATIONS_ERASER: 'RCV_Web_Annotations_eraser',
    GET_USER_MEDIA: 'RCV_Web_inMeeting_getUserMedia',
    TMP_ANNOTATIONS_LIMIT: 'RCV_Web_inMeeting_hitAnnotationsLimit',
    ADJUST_BREAKOUT_ROOMS_PANEL: 'RCV_Web_adjustBreakoutRoomsPanel',
    ECHO_WARNING_FOR_HOST_AND_MODERATOR: 'RCV_Web_inMeeting_echoWarningForHostAndModerator',
    ECHO_WARNING_FOR_PARTICIPANT_SELF: 'RCV_Web_inMeeting_echoWarningForParticipantSelf',
    ECHO_LEAK_SELF_STATS: 'RCV_Web_inMeeting_echoLeakSelfStats',
    SHARE_COMPUTER_MEDIA: 'RCV_Web_inMeeting_Share_computer_media',
    CPU_ADAPTATION_V2: 'RCV_Web_inMeeting_CpuAdaptationV2',
    CPU_REDUCE_INCOMING_VIDEO_QUALITY: 'RCV_Web_inMeeting_CPU_reduceQuality',
    CPU_REDUCE_INCOMING_VIDEO_QUALITY_V2: 'RCV_Web_inMeeting_CPU_reduceIncomingVideoQuality_v2',
    CPU_DISABLE_INCOMING_VIDEOS: 'RCV_Web_inMeeting_CPU_reduceNumber',
    CPU_DISABLE_INCOMING_VIDEOS_V2: 'RCV_Web_inMeeting_CPU_disableIncomingVideo_v2',
    CPU_REDUCE_OUTGOING_VIDEO_QUALITY: 'RCV_Web_inMeeting_CPU_reduceOutgoingVideoQuality',
    CPU_DISABLE_OUTGOING_VIDEO: 'RCV_Web_inMeeting_CPU_disableOutgoingVideo',
    CPU_ADAPT_OUTGOING_SHARING_CODEC: 'RCV_Web_inMeeting_CPU_adaptOutgoingSharingCodec',
    CPU_ADAPT_OUTGOING_VIDEO_CODEC: 'RCV_Web_inMeeting_CPU_adaptOutgoingVideoCodec',
    CPU_ADAPT_OUTGOING_SHARING_FPS: 'RCV_Web_inMeeting_CPU_adaptOutgoingSharingFps',
    CPU_ADAPT_OUTGOING_SHARING_RESOLUTION: 'RCV_Web_inMeeting_CPU_adaptOutgoingSharingResolution',
    PUBNUB_PERMISSIONS_DELAYED: 'RCV_Web_inMeeting_pubnubPermissionsDelayed',
    REC_CHANGE_CONTROL_PERMISSIONS: 'RCV_Web_Rec_Change_ControlPermissions',
    WEB_PANEL_CLOSE: 'RCV_Web_inMeeting_Panel_Close',
    WEB_PANEL_PIN_UNPIN: 'RCV_Web_inMeeting_Panel_PinUnpin',
    LT_START: 'RCV_Web_LT_Start',
    LT_PAUSE_RESUME: 'RCV_Web_LT_PauseResume',
    MAC_MIC_WARNING_SHOWN: 'RCV_Web_InMeeting_MacMicWarningShown',
    MIC_SILENCE_WARNING: 'RCV_Web_InMeeting_MicSilenceWarning',
    SHARING_CONFIRMATION_DELAYS: 'RCV_Web_inMeeting_SharingConfirmationDelays',
    PREVIEW_ZOOM_IN_MEETING: 'RCV_Web_inMeeting_zoomMeeting',
    USER_AUDIO_VIDEO_ISSUE: 'RCV_Web_inMeeting_userAudioVideoIssue',
    AUDIO_VIDEO_BAD_NETWORK_NOTIFICATION: 'RCV_Web_inMeeting_audioVideoBadNetworkNotification',
    VIEWER_SCREEN_SHARE_ISSUE: 'RCV_Web_inMeeting_viewerScreenShareIssue',
    BWE_STATS: 'RCV_Web_inMeeting_BWEStats',
    RECOVERY_SUMMARY: 'RCV_Web_inMeeting_RecoverySummary',
    MIC_MENU_OPTION: 'RCV_Web_inMeeting_micMenuOption',
    SYSTEM_DEFAULT_AUDIO_CHANGES: 'RCV_Web_inMeeting_systemDefaultAudioChanges ',
    RENAME_PARTICIPANT: 'RCV_Web_renameParticipant',
    OPEN_RENAME_PARTICIPANT_FORM: 'RCV_Web_openRenameParticipantForm',
    SEQUOIA_ALERT_CLOSED: 'RCV_Web_inMeeting_sequoiaAlertClosed',
    MEDIA_CAPTURING_VIDEO: 'RCV_Web_inMeeting_MediaCapturing_Video',
    MEDIA_CAPTURING_AUDIO: 'RCV_Web_inMeeting_MediaCapturing_Audio',
    MEDIA_CAPTURING_SCREENSHARING: 'RCV_Web_inMeeting_MediaCapturing_ScreenSharing',
    MEDIA_CAPTURING_MONITOR: 'RCV_Web_inMeeting_MediaCapturingStats_Monitoring',
    MINIMIZE_PARTICIPANT_VIDEO: 'RCV_Web_minimizeParticipantVideo',
    PIP_ENTER: 'RCV_Web_inMeeting_PiP_enter',
    PIP_EXIT: 'RCV_Web_inMeeting_PiP_exit',
    UNIFIED_INVITE_ENTRY: 'RCV_Web_unifiedInviteEntry',
    UNIFIED_INVITE_PAGE: 'RCV_Web_unifiedInvitePage',
    UNIFIED_INVITE_RESPONSE_RECEIVED: 'RCV_Web_unifiedInviteResponseReceived',
    UNIFIED_INVITE_ERROR: 'RCV_Web_unifiedInviteError',
};

export const OUTSIDE_MEETING = {
    MEETING_SCHEDULED: 'RCV_Web_meetingScheduled',
    SCHEDULE_ON_BEHALF_NEW_MEETING: 'RCV_Web_ScheduleOnBehalf_NewMeeting',
    WELCOME_SCREEN_BUTTONS_TAPPED: 'RCV_Web_authentication_welcomePageButton',
    AUTHENTICATION_SIGN_OUT: 'RCV_Web_authentication_signOut',
    QUALITY_FEEDBACK: 'RCV_Web_QUALITY_FEEDBACK',
    DISMISS_QUALITY_FEEDBACK: 'RCV_Web_dismiss_rating',
    PAIRED_AUDIO_SELECTED: 'RCV_Web_Settings_PairedAudioDeviceSelected',
    SHARE_RECORDING: 'RCV_Web_homepageSignedIn_buttonClickOnShareRecording',
    RCV_WEB_IS_CPU_MATCH_HD_REQ: 'RCV_Web_isCPUmatchHDreq',
    NOISE_REDUCTION_LEVEL_CHANGE: 'RCV_Web_NoiseReduction_OutMeeting_settings_change',
    REQUIRE_AUTHENTICATION: 'RCV_Web_requireAuthentication_onlyAuthenticatedUserCanJoin',
    WELCOME_PAGE_CLICK: 'RCV_Web_welcomeScreen_buttonClick',
    JOIN_MODAL_CLICK: 'RCV_Web_joinMeetingScreen_buttonClick',
    MEETING_LINK_PAGE_CLICK: 'RCV_Web_visitMeetingLinkScreen_buttonClick',
    REQUIRE_SIGNIN_PAGE_CLICK: 'RCV_Web_meetingRequireSignin_buttonClick',
    NOT_SUPPORT_PAGE_CLICK: 'RCV_Web_browserNotSupported_buttonClick',
    MEDIA_TRACKS_LEAK: 'RCV_Web_mediaTracksLeak',
    AUDIO_VIDEO_PREVIEW_PAGE: 'RCV_Web_audioVideoPreview_page',
    AUDIO_VIDEO_PREVIEW_BUTTON: 'RCV_Web_audioVideoPreviewButton',
    AV_PERMISSIONS_GATE: 'RCV_Web_avPermissionsGate',
    NOTES_REPORT_ISSUES: 'RCV_Web_rcv_notesReportIssues',
};

export const REMOTE_CONTROL = {
    REQUEST_SENT: 'RCV_Web_RDC_requestControl',
    REQUEST_PROCESSED: 'RCV_Web_RDC_requestIsClosed',
    STOPPED: 'RCV_Web_RDC_endRDC',
    ALLOW_REQUESTS: 'RCV_Web_RDC_allowRequests',
};

export const PHONE_TO_VIDEO = {
    RCV_WEB_IN_MEETING_SEND_SMS_STATE: 'RCV_Web_inMeeting_sendSMS_state',
    VIEWED_RCV_WEB_IN_MEETING_SHARE_SCREEN_GUIDED_TOUR_PAGE:
        'Viewed RCV_Web_inMeetingShareScreenGuidedTour Page',
    RCV_WEB_IN_MEETING_SHARE_SCREEN_GUIDED_TOUR: 'RCV_Web_inMeetingShareScreenGuidedTour',
    VIEWED_RCV_WEB_IN_MEETING_JOIN_AUDIO_GUIDED_TOUR_PAGE:
        'Viewed RCV_Web_inMeetingJoinAudioGuidedTour Page',
    VIEWED_RCV_WEB_IN_MEETING_SHARE_VIEW_GUIDED_TOUR_PAGE:
        'Viewed RCV_Web_inMeetingShareViewGuidedTour Page',
};
